const areContextsTheSame = <T extends Record<string, unknown>>(
	left: T,
	right: Record<string, unknown>,
): boolean => !Object.entries(left).every(([k, v]) => right.hasOwnProperty(k) && right[k] === v);

export const isContextChanged = <T extends Record<string, unknown>>(
	previousContext: T,
	newContext: Record<string, unknown>,
): boolean =>
	previousContext &&
	newContext &&
	areContextsTheSame(previousContext, newContext) &&
	areContextsTheSame(newContext, previousContext);
